import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useModal } from '../../../../../hooks/use-modal';
import ModalPortal from '../../../../../components/modal-portal';

import { sendTestEmail } from '../../api';
import { apiError } from '../../on-api-error';
import messages from '../../messages';

import ConfirmSendTestModal from '../confirm-send-test-modal';
import SentTestModal from '../confirm-send-test-modal/sent-test-modal';
import { useIsAccountEmailVerifiedSellerSetting } from '../../../../../hooks/use-seller-setting';
import { VerifyEmailModal } from '../../../../../components/verify-email-modal';

const SendTest = ({ children }) => {
  const [emailTemplate, setEmailTemplate] = useState();
  const { open, close, isOpen } = useModal();
  const [isSending, setIsSending] = useState(false);
  const [sentToStoreGuid, setSentToStoreGuid] = useState();
  const isAccountEmailVerified = useIsAccountEmailVerifiedSellerSetting();
  const { close: closeUnverifiedModal, isOpen: isUnverifiedModalOpen, open: openUnverifiedModal } = useModal();

  const onConfirmSendTest = (storeGuid) => {
    setIsSending(true);
    sendTestEmail(emailTemplate, storeGuid)
      .then(() => {
        setIsSending(false);
        setSentToStoreGuid(storeGuid);
      })
      .catch(() => {
        setIsSending(false);
        apiError(messages.apiSendTestError);
      });
  };

  const onSendTestClicked = (template) => {
    if (!isAccountEmailVerified) {
      openUnverifiedModal();
      return;
    }
    setEmailTemplate(template);
    open();
  };
  const onModalClose = () => {
    close();
    setEmailTemplate(undefined);
    setIsSending(false);
    setSentToStoreGuid(undefined);
  };
  return (
    <>
      {children({ onSendTestClicked })}
      {isOpen && (
        <ModalPortal onClose={onModalClose}>
          {!sentToStoreGuid && <ConfirmSendTestModal isSending={isSending} onConfirm={onConfirmSendTest} />}
          {sentToStoreGuid && <SentTestModal storeGuid={sentToStoreGuid} />}
        </ModalPortal>
      )}
      {isUnverifiedModalOpen && <VerifyEmailModal closeUnverifiedModal={closeUnverifiedModal} />}
    </>
  );
};

SendTest.propTypes = {
  children: PropTypes.func.isRequired,
};

export default SendTest;
